import { template as template_0c14a05396bb46d5b0de798abb642830 } from "@ember/template-compiler";
import { t } from 'ember-intl';
import { IMPORT_TYPES_ALLOWED_AS_WI } from 'eflex/constants/file-types';
import Component from '@glimmer/component';
import { service } from '@ember/service';
import PropertiesDrawer from 'eflex/components/work-instruction-editor/properties-drawer';
import BsButton from 'eflex/components/bs-button';
import BsTooltip from 'eflex/components/bs-tooltip';
import FileInput from 'eflex/components/file-input';
import BsButtonGroup from 'ember-bootstrap/components/bs-button-group';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import { optional } from '@eflexsystems/ember-composable-helpers';
import { or, notEq } from 'ember-truth-helpers';
import { ShapeTypes } from 'eflex/constants/work-instructions/tool-props';
import { tracked } from '@glimmer/tracking';
import { fn } from '@ember/helper';
import onClickOutside from 'ember-click-outside/modifiers/on-click-outside';
const ToolButton = class extends Component {
    static{
        template_0c14a05396bb46d5b0de798abb642830(`
    <BsButton
      @disabled={{@disabled}}
      @type={{if @selected "primary text-white" "secondary"}}
      @onClick={{optional @onClick}}
      class="tool-button border-0 lh-1 {{if @selected "selected"}}"
      ...attributes
    >
      {{#if @icon}}
        <FaIcon @icon={{@icon}} />
      {{else}}
        {{yield}}
      {{/if}}
      {{#if @tooltip}}
        <BsTooltip @title={{@tooltip}} @placement="right" @delayShow={{600}} />
      {{/if}}
    </BsButton>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    ;
};
export default class WorkInstructionEditorToolButtons extends Component {
    supportedFileTypes = IMPORT_TYPES_ALLOWED_AS_WI;
    @service
    imageEditor;
    @tracked
    showShapeMenu = false;
    @tracked
    shape;
    get shapeTypes() {
        return [
            {
                value: ShapeTypes.RECT,
                icon: 'square',
                size: 'sm'
            },
            {
                value: ShapeTypes.ELLIPSE,
                icon: 'circle',
                size: 'sm'
            },
            {
                value: ShapeTypes.TRIANGLE,
                icon: 'play',
                class: 'fa-rotate-270'
            }
        ];
    }
    get _selectedShape() {
        return this.shapeTypes.find((s)=>s.value === this.args.selectedShape);
    }
    toggleShapeMenu = ()=>{
        this.showShapeMenu = !this.showShapeMenu;
    };
    _imagesAction = (files, resetInput)=>{
        this.args.imagesAction?.(files);
        resetInput();
    };
    _shapeAction = (shape)=>{
        this.args.shapeAction();
        this.args.selectShape(shape.value);
        this.showShapeMenu = false;
    };
    toolAction = (action)=>{
        action();
        this.showShapeMenu = false;
    };
    static{
        template_0c14a05396bb46d5b0de798abb642830(`
    <div
      class="component-work-instruction-editor-tool-buttons"
      ...attributes
    >
      <PropertiesDrawer
        class="editor-controls d-flex flex-column align-items-center h-100 p-2"
        @collapsed={{@collapsed}}
      >
        <div class="bg-white shadow d-flex flex-column flex-wrap rounded p-1 my-auto mh-100">
          <ToolButton
            class="move-button mb-1"
            @onClick={{fn this.toolAction @moveAction}}
            @selected={{@isNormalMode}}
            @disabled={{@disableAll}}
            @tooltip={{t "imageEditor.selection"}}
            @icon="arrow-pointer"
          />
          <ToolButton
            class="text-button mb-1"
            @onClick={{fn this.toolAction @textAction}}
            @selected={{@isTextMode}}
            @disabled={{@disableAll}}
            @tooltip={{t "imageEditor.text"}}
          >
            <svg class="custom-icon icon-text" />
          </ToolButton>
          <ToolButton
            class="lines-button mb-1"
            @onClick={{fn this.toolAction @lineAction}}
            @selected={{@isLineMode}}
            @disabled={{@disableAll}}
            @tooltip={{t "imageEditor.lines"}}
          >
            <svg class="custom-icon icon-line" />
          </ToolButton>
          <div class="position-relative mb-1">
            <ToolButton
              class="shapes-button {{if @isShapeMode this._selectedShape.value}}"
              @onClick={{this.toggleShapeMenu}}
              @selected={{@isShapeMode}}
              @disabled={{@disableAll}}
              @tooltip={{t "imageEditor.shapes"}}
            >
              <FaIcon
                class="{{if @isShapeMode this._selectedShape.class}} fa-fw"
                @icon={{if @isShapeMode this._selectedShape.icon "square-full"}}
                @prefix={{unless @isShapeMode "far"}}
                @size={{if @isShapeMode this._selectedShape.size}}
              />
            </ToolButton>
            {{#if this.showShapeMenu}}
              <div
                class="
                  shapes-menu
                  d-flex flex-nowrap position-absolute start-0 top-0 ms-5 bg-white rounded shadow p-1 mt-n1 z-3
                "
                {{onClickOutside (fn (mut this.showShapeMenu) false)}}
              >
                {{#each this.shapeTypes as |shape|}}
                  <BsButton
                    class="tool-button shape-button {{shape.value}} border-0 lh-1"
                    @onClick={{fn this._shapeAction shape}}
                    @disabled={{@disableAll}}
                  >
                    <FaIcon @icon={{shape.icon}} @prefix="fas" @size={{shape.size}} class={{shape.class}} />
                  </BsButton>
                {{/each}}
              </div>
            {{/if}}
          </div>
          <FileInput
            @class="upload-image mb-1"
            accept={{this.supportedFileTypes}}
            @disabled={{@disableAll}}
            @onChange={{this._imagesAction}}
            @onClick={{@onUploadImage}}
          >
            <ToolButton
              class="images-button w-100 bg-transparent"
              @disabled={{@disableAll}}
              @icon="image"
            />
            {{#unless @disableAll}}
              <BsTooltip @title={{t "imageEditor.images"}} @placement="right" @delayShow={{400}} />
            {{/unless}}
          </FileInput>
          <ToolButton
            class="icon-button px-2 mb-1"
            @onClick={{fn this.toolAction @iconAction}}
            @selected={{@isIconMode}}
            @disabled={{@disableAll}}
            @tooltip={{t "imageEditor.icons"}}
          >
            <svg class="custom-icon icon-svg" />
          </ToolButton>
          <ToolButton
            class="crop-button mb-1"
            @onClick={{fn this.toolAction @cropAction}}
            @selected={{@isCropMode}}
            @disabled={{or (notEq @selectedType "image") @disableAll}}
            @tooltip={{t "imageEditor.crop"}}
            @icon="crop"
          />
        </div>
        <div class="additional-controls mb-2">
          <BsButtonGroup
            class="wie-grid-toggle"
            @type="checkbox"
            @value={{@enableGridValue}}
            @onChange={{optional @toggleGridAction}}
            @disabled={{@disableAll}}
            as |bg|
          >
            <bg.button
              @value={{true}}
              @type={{if @enableGridValue "primary grid-on text-white" "secondary"}}
              disabled={{@disableAll}}
              class="border-0 lh-1 p-2"
            >
              <FaIcon @icon="table-cells" @prefix="fas" class="fa-fw" />
              <BsTooltip @title={{t "grid"}} @delayShow={{600}} />
            </bg.button>
          </BsButtonGroup>
        </div>
      </PropertiesDrawer>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
